function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m10.692 1.691 7.894 7.894a2 2 0 0 1 0 2.828l-6.172 6.172a2 2 0 0 1-2.828 0l-7.894-7.894a2 2 0 0 1-.57-1.662l.686-5.486a1.998 1.998 0 0 1 1.736-1.736l5.486-.686a2 2 0 0 1 1.662.57zM6.5 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgTag;